// Month filter for the Selected / Rejected tabs. Keys are local-time "YYYY-MM"
// so "October" means October in the recruiter's own time zone.

export const monthKey = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

const monthLabel = (key) => {
  const [y, m] = key.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleString('en-US', { month: 'long', year: 'numeric' });
};

// Newest first, with counts. A remembered month that no longer has candidates is
// kept (count 0) so the user can still see and clear it.
export const buildMonthOptions = (candidates, dateField, selected) => {
  const counts = new Map();
  for (const c of candidates || []) {
    const k = monthKey(c?.[dateField]);
    if (k) counts.set(k, (counts.get(k) || 0) + 1);
  }
  if (selected && !counts.has(selected)) counts.set(selected, 0);
  return [...counts.entries()]
    .sort((a, b) => (a[0] < b[0] ? 1 : -1))
    .map(([key, count]) => ({ key, label: monthLabel(key), count }));
};

export const filterByMonth = (candidates, dateField, selected) =>
  selected ? (candidates || []).filter((c) => monthKey(c?.[dateField]) === selected) : candidates;

const storageKey = (screeningId, tab) => `tc:month:${screeningId}:${tab}`;

export const loadMonth = (screeningId, tab) => {
  if (!screeningId) return '';
  try {
    const v = localStorage.getItem(storageKey(screeningId, tab)) || '';
    return /^\d{4}-\d{2}$/.test(v) ? v : '';
  } catch {
    return '';
  }
};

export const saveMonth = (screeningId, tab, value) => {
  if (!screeningId) return;
  try {
    if (value) localStorage.setItem(storageKey(screeningId, tab), value);
    else localStorage.removeItem(storageKey(screeningId, tab));
  } catch { /* storage blocked — filter still works for this session */ }
};
